import { Spin } from "antd";

import Review, { ItemReview } from "./Review";

import styles from "./index.module.css";
// import mgGlass from "assets/svg/magnifying-glass.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import { ModalComponentV1 } from "Components/ModalComponentV1";
import { CustomButton } from "Components/CustomButton";
// import { CustomInput } from "Components/CustomInput";

type Props = {
  reviews: ItemReview[];
  isModalOpen: boolean;
  reviewCount: number;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  onDelete: (id: string) => void;
  hasMore: boolean;
  loadMore: () => void;
};

const CommentsModal = ({ reviews, isModalOpen, setIsModalOpen, reviewCount, onDelete, hasMore, loadMore }: Props) => {
  return (
    <ModalComponentV1
      title={`${reviewCount} Review${reviewCount ? (reviewCount === 1 ? "" : "s") : "s"}`}
      isOpen={isModalOpen}
      className={styles.modal}
      onClose={() => setIsModalOpen(false)}
    >
      {!reviews ? (
        <Spin />
      ) : (
        <>
          {/* <CustomInput
            className={styles.inputSearch}
            placeholder="Search"
            suffix={<img src={mgGlass} alt="magnifyingglass" />}
          /> */}
          <div className={styles.list} id="scrollReviewItemElement">
            <InfiniteScroll
              dataLength={reviews.length}
              hasMore={hasMore}
              className={styles.infiniteScroll}
              loader={<Spin />}
              height={488}
              next={() => {
                loadMore();
              }}
              scrollableTarget="scrollReviewItemElement"
            >
              {reviews.map((item) => (
                <div key={item.id} className={styles.reviewWrapper}>
                  <Review item={item} onDelete={onDelete} />
                </div>
              ))}
            </InfiniteScroll>
          </div>
          <div className={styles.buttonsWrapper}>
            <CustomButton sizeButton="large" typeButton="primary" type="primary" onClick={() => setIsModalOpen(false)}>
              Close
            </CustomButton>
          </div>
        </>
      )}
    </ModalComponentV1>
  );
};

export default CommentsModal;
